import TransitionSelector from '../../BatchCheckpointsScanner/ScannerPanel/TransitionSelector';
import { BulkParseResult } from '../../../hooks/BulkUpload/parseBulkCodes';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { UploadFileOutlined as UploadIcon } from '@mui/icons-material';
import { Option } from '@/components/inputs/AutocompleteInput';
import { DialogContent, DialogActions } from '@mui/material';
import HighlightedCodesTextarea from './HighlightedCodesTextarea';
import UnrecognizedLinesPanel from './UnrecognizedLinesPanel';
import ParseStatsChips from './ParseStatsChips';
import SectionHeader from '../../SectionHeader';
import { GlobalButton } from '@/components';

interface InputViewProps {
  transition: Option | null;
  setTransition: (option: Option | null) => void;
  transitionOptions: Option[];
  isTransitionsLoading: boolean;
  rawText: string;
  setRawText: (value: string) => void;
  parseStats: BulkParseResult['stats'];
  unrecognizedLines: string[];
  canSubmit: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const InputView = ({
  transition,
  setTransition,
  transitionOptions,
  isTransitionsLoading,
  rawText,
  setRawText,
  parseStats,
  unrecognizedLines,
  canSubmit,
  onClose,
  onConfirm,
}: InputViewProps) => (
  <>
    <DialogContent sx={{ pb: 1 }}>
      <div className='flex flex-col gap-4'>
        <SectionHeader
          title='Carga masiva de pedidos'
          icon={UploadIcon}
          colorClass='bg-[#ff7500]'
          subtitle='Pegá la columna de números de envío copiada desde Excel'
        />

        <TransitionSelector
          transition={transition}
          setTransition={setTransition}
          transitionOptions={transitionOptions}
          isTransitionsLoading={isTransitionsLoading}
          disabled={false}
        />

        <HighlightedCodesTextarea
          value={rawText}
          onChange={setRawText}
          unrecognizedLines={unrecognizedLines}
          placeholder='Ingrese los números de envío, uno por línea'
        />

        <ParseStatsChips stats={parseStats} />
        <UnrecognizedLinesPanel lines={unrecognizedLines} />
      </div>
    </DialogContent>
    <DialogActions className='px-6 pb-6 gap-3'>
      <GlobalButton action={onClose} variant={GlobalButtonVariant.secondaryButton}>
        Cancelar
      </GlobalButton>
      <GlobalButton
        action={onConfirm}
        variant={GlobalButtonVariant.primaryButton}
        disabled={!canSubmit}
      >
        Aplicar cambios de estado
      </GlobalButton>
    </DialogActions>
  </>
);

export default InputView;
